import axios from "axios";

export async function token(token) {
	if (!token) {
		throw new Error("Token required");
	}
	const response = await axios({
		method: "GET",
		url: `${process.env.REACT_APP_BACKEND_URL}/v1/token`,
		headers: {
			Authorization: `Bearer ${token}`
		}
	});
	return response.data;
}
